export default __webpack_public_path__ + "static/media/description-name3.882ae14f.png";